import { Alert } from "@mui/material";
import React from "react";

 const NotificationView  = (props) => {

    // message needs to be display on Notification Viewckbar

    let  {
      message,
      severity = 'error',
      variant = 'outlined',
      specify,
      margin = "20px",
      width
  } = props;

  const getWidth = () => {
     let widthP = message && (message.length/155 ) * 100;
    if(specify == "infoEditParent") {
        return 63.95 + '%'
    }
    if(window.innerWidth < 770){
        console.log("INSIDE Window width" + window.innerWidth < 780);
         widthP = 98 + '%';
         return widthP;
      }
   else if(widthP >= 98){
        widthP = 98 + '%';
    }else {
        widthP = widthP + '%';
    }
    

    return widthP;
}


    const AlertStyle = ()=>{
        if(severity == "success"){
            if(variant == "outlined"){
                return {width: getWidth() ,
                       color: '#008757',
                       borderColor: '#008757',
                       fontFamily: 'Avenir',
                       fontSize: '14px',
                       fontStyle: 'normal',
                          marginTop: '20px',
                          marginBottom: '20px',
                      }       
               }else{
                return {width: getWidth() ,
                    color: '#008757',
                    borderColor: '#FFFFFF',
                    fontFamily: 'Avenir',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    marginTop: '20px',
                    marginBottom: '20px',
                    background: '#FFFFFF',
                   }
               }
            }
            
         if(severity == "error"){
            if(variant == "outlined"){
                return {width:  getWidth() ,
                    color: '#DE3412',
                    borderColor: '#DE3412',
                    fontFamily: 'Avenir',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    marginTop: '20px',
                    marginBottom: '20px',
                   }       
            }else{
            return {width:  getWidth() ,
                    color: '#DE3412',
                    borderColor: '#ffffff',
                    fontFamily: 'Avenir',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    marginTop: '20px',
                    marginBottom: '20px',
                    background: '#FFFFFF',
                   }       
            }
        }

            if(severity == "info"){
                
                return {width: width !== null ? width : getWidth() ,
                        color: '#000000',
                        borderColor: '#000000',
                        fontFamily: 'Macys Sans',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        marginTop: '20px',
                        marginBottom: '20px',
                        marginLeft: margin,
                        fontWeight:400,
                       }       
                } 

                if(severity == "warning"){
            
                       return {width: getWidth() ,
                            color: '#AB0000',
                            borderColor: '#AB0000',
                            fontFamily: 'Macys Sans',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            marginTop: '20px',
                            marginBottom: '20px',
                            marginLeft: "20px",
                            fontWeight:400,
                            "& .MuiAlert-icon": {
                                color: "#E01A2B"
                              }
                           }       
                    } 

            return {width: getWidth(),
                    color: '#000000',
                    borderColor: '#000000',
                    fontFamily: 'Macys Sans',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    marginTop: '20px',
                    marginBottom: '20px',
                    background : '#ffffff'}       
            }

    return <div> 
                <Alert 
                    severity={severity}
                    variant={variant} 
                    sx={AlertStyle}>
                    {message}
                </Alert> 
         </div>


}



export default NotificationView;